/**
 * SPIN WHEEL POPUP - JavaScript
 * Handles wheel drawing, spinning animation, and prize logic
 */

(function() {
  'use strict';

  // Configuration
  const COOKIE_NAME = 'spin_wheel_used';
  let prizes = [];
  let popupDelay = 3;
  let cookieExpiryDays = 7;
  let isSpinning = false;
  let currentRotation = 0;

  // DOM Elements
  let popup, canvas, ctx, spinBtn, closeBtn, overlay, triggerBtn;
  let gameStep, resultStep, prizeValueEl, discountCodeEl, discountCodeContainer, copyCodeBtn, shopNowBtn;

  /**
   * Initialize the spin wheel
   */
  function init() {
    // Get DOM elements
    popup = document.getElementById('spinWheelPopup');
    if (!popup) return;

    canvas = document.getElementById('wheelCanvas');
    if (!canvas) return;

    ctx = canvas.getContext('2d');
    spinBtn = document.getElementById('spinBtn');
    closeBtn = popup.querySelector('.spin-wheel-close');
    overlay = popup.querySelector('.spin-wheel-overlay');
    triggerBtn = document.getElementById('spinWheelTriggerBtn');
    gameStep = popup.querySelector('.spin-wheel-game-step');
    resultStep = popup.querySelector('.spin-wheel-result-step');
    prizeValueEl = document.getElementById('prizeValue');
    discountCodeEl = document.getElementById('discountCode');
    discountCodeContainer = document.getElementById('discountCodeContainer');
    copyCodeBtn = document.getElementById('copyCodeBtn');
    shopNowBtn = document.getElementById('shopNowBtn');

    // Get configuration
    prizes = window.spinWheelPrizes || getDefaultPrizes();
    popupDelay = parseInt(popup.dataset.delay) || 3;
    cookieExpiryDays = parseInt(popup.dataset.cookieDays) || 7;

    // COOKIE CHECK REMOVED - Wheel shows on every page refresh
    // No restriction on number of spins

    // Draw the wheel
    drawWheel();

    // DON'T auto-show popup - only show when trigger button is clicked
    // setTimeout(showPopup, popupDelay * 1000);

    // Event listeners
    if (triggerBtn) {
      triggerBtn.addEventListener('click', openWheelFromTrigger);
    } else {
    }
    spinBtn.addEventListener('click', handleSpin);
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);
    copyCodeBtn.addEventListener('click', copyDiscountCode);
    shopNowBtn.addEventListener('click', handleShopNow);

  }

  /**
   * Open wheel from trigger button
   */
  function openWheelFromTrigger() {

    // Reset wheel state
    gameStep.classList.add('active');
    resultStep.classList.remove('active');

    // Re-enable spin button
    spinBtn.disabled = false;
    spinBtn.querySelector('.spin-btn-text').textContent = spinBtn.querySelector('.spin-btn-text').dataset.originalText || 'SPIN THE WHEEL';

    // Reset wheel rotation
    canvas.style.transform = `rotate(0deg)`;
    isSpinning = false;

    // Show popup
    showPopup();
  }

  /**
   * Default prizes if none configured
   */
  function getDefaultPrizes() {
    return [
      { text: 'Buy 2 at ₹799', code: 'BUY2AT799', color: '#242526', textColor: '#faf7c3', probability: 0 },
      { text: 'Buy 3 at ₹1299', code: 'BUY3AT1299', color: '#d21404', textColor: '#FFFFFF', probability: 0 },
      { text: 'Buy 4 at ₹1599', code: 'BUY4AT1599', color: '#22292d', textColor: '#faf7c3', probability: 0 },
      { text: 'Buy 5 at ₹1799', code: 'BUY5AT1799', color: '#3a3b3c', textColor: '#faf7c3', probability: 0 },
      { text: '15% OFF', code: 'SPIN15', color: '#d21404', textColor: '#FFFFFF', probability: 0 },
      {
        text: 'FREE Gifts on ₹999+',
        code: 'FREEGIFTS999',
        color: '#3c9343',
        textColor: '#FFFFFF',
        probability: 100,
        isFreeGift: true,
        description: 'Photo Frame + Keychain + Ring + Free Shipping'
      }
    ];
  }

  /**
   * Draw the wheel on canvas
   */
  function drawWheel() {
    const numPrizes = prizes.length;
    const arcSize = (2 * Math.PI) / numPrizes;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = canvas.width / 2 - 10;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw each segment
    prizes.forEach((prize, index) => {
      const angle = index * arcSize;

      // Draw segment
      ctx.beginPath();
      ctx.fillStyle = prize.color;
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, angle, angle + arcSize);
      ctx.lineTo(centerX, centerY);
      ctx.fill();

      // Draw border
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 3;
      ctx.stroke();

      // Draw text
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(angle + arcSize / 2);
      ctx.textAlign = 'center';
      ctx.fillStyle = prize.textColor || '#FFFFFF';

      // Split text into multiple lines for better readability
      const words = prize.text.split(' ');
      const textRadius = radius * 0.65;

      // Handle different text lengths
      if (words.length >= 4) {
        // 4+ words: Split into 3 lines (e.g., "Buy 2 at ₹799")
        ctx.font = 'bold 14px Arial, sans-serif';
        ctx.fillText(words[0] + ' ' + words[1], textRadius, -12);
        ctx.fillText(words[2], textRadius, 4);
        ctx.fillText(words[3], textRadius, 20);
      } else if (words.length === 3) {
        // 3 words: Split into 2 lines
        ctx.font = 'bold 15px Arial, sans-serif';
        ctx.fillText(words[0] + ' ' + words[1], textRadius, -5);
        ctx.fillText(words[2], textRadius, 15);
      } else if (words.length === 2) {
        // 2 words: Split into 2 lines
        ctx.font = 'bold 16px Arial, sans-serif';
        ctx.fillText(words[0], textRadius, -5);
        ctx.fillText(words[1], textRadius, 15);
      } else {
        // Single word
        ctx.font = 'bold 18px Arial, sans-serif';
        ctx.fillText(prize.text, textRadius, 5);
      }

      ctx.restore();
    });

    // Draw center circle
    ctx.beginPath();
    ctx.fillStyle = '#FFFFFF';
    ctx.arc(centerX, centerY, 30, 0, 2 * Math.PI);
    ctx.fill();
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 3;
    ctx.stroke();

    // Draw center dot
    ctx.beginPath();
    ctx.fillStyle = '#000000';
    ctx.arc(centerX, centerY, 8, 0, 2 * Math.PI);
    ctx.fill();
  }

  /**
   * Show the popup
   */
  function showPopup() {

    popup.classList.add('active');

    setTimeout(() => {
      popup.classList.add('visible');
    }, 10);
  }

  /**
   * Close the popup
   */
  function closePopup() {
    popup.classList.remove('visible');
    setTimeout(() => {
      popup.classList.remove('active');
    }, 400);
  }

  /**
   * Handle spin button click
   */
  function handleSpin() {
    if (isSpinning) return;

    isSpinning = true;
    spinBtn.disabled = true;
    spinBtn.querySelector('.spin-btn-text').textContent = 'SPINNING...';

    // Select winning prize
    const winningPrize = selectWinningPrize();
    const winningIndex = prizes.indexOf(winningPrize);

    // Calculate rotation
    const numPrizes = prizes.length;
    const arcSize = 360 / numPrizes;
    const randomOffset = Math.random() * arcSize;

    // Spin multiple times + land on prize (adjust for pointer at top)
    const spins = 5 + Math.random() * 3; // 5-8 full rotations
    const finalAngle = (spins * 360) + (360 - (winningIndex * arcSize + arcSize / 2)) + randomOffset;

    currentRotation += finalAngle;

    // Apply rotation
    canvas.style.transform = `rotate(${currentRotation}deg)`;
    canvas.classList.add('spinning');

    // Show result after spin
    setTimeout(() => {
      showResult(winningPrize);
      canvas.classList.remove('spinning');
      // Cookie setting removed - unlimited spins
    }, 4000);
  }

  /**
   * Select winning prize based on probability
   */
  function selectWinningPrize() {
    // Calculate total probability
    const totalProbability = prizes.reduce((sum, prize) => sum + (prize.probability || 0), 0);

    // Generate random number
    let random = Math.random() * totalProbability;

    // Select prize based on probability
    for (let prize of prizes) {
      random -= (prize.probability || 0);
      if (random <= 0) {
        return prize;
      }
    }

    // Fallback to first prize
    return prizes[0];
  }

  /**
   * Show the result screen
   */
  function showResult(prize) {
    // Hide game step
    gameStep.classList.remove('active');

    // Check if this is the free gift prize
    if (prize.isFreeGift) {
      // Store that user won free gifts
      localStorage.setItem('wonFreeGifts999', 'true');
      localStorage.setItem('freeGiftsExpiry', Date.now() + (7 * 24 * 60 * 60 * 1000)); // 7 days

      // Show special free gifts message
      prizeValueEl.innerHTML = `
        <div class="free-gifts-result">
          <h3 style="color: #d21404; margin-bottom: 16px;">🎁 ${prize.text}</h3>
          <div class="free-gifts-list" style="text-align: left; margin: 20px 0;">
            <p style="margin-bottom: 12px; font-size: 16px;">✅ Free Photo Frame</p>
            <p style="margin-bottom: 12px; font-size: 16px;">✅ Personalized Keychain</p>
            <p style="margin-bottom: 12px; font-size: 16px;">✅ Custom Name Ring</p>
            <p style="margin-bottom: 12px; font-size: 16px;">✅ FREE Shipping (All India)</p>
          </div>
          <p style="font-size: 14px; color: #666; margin-top: 16px;">
            Just spend ₹999 or more and we'll add your free gifts at checkout!
          </p>
        </div>
      `;

      // Hide discount code section for free gift
      discountCodeContainer.style.display = 'none';
    } else {
      // Normal prize display
      prizeValueEl.textContent = prize.text;

      // Show/hide discount code
      if (prize.code && prize.code.trim() !== '') {
        discountCodeEl.value = prize.code;
        discountCodeContainer.style.display = 'block';
      } else {
        discountCodeContainer.style.display = 'none';
      }
    }

    // Set shop button URL
    if (prize.redirectUrl) {
      shopNowBtn.onclick = () => {
        window.location.href = prize.redirectUrl;
      };
    } else {
      shopNowBtn.onclick = () => {
        closePopup();
        // Optional: scroll to products section
        const productsSection = document.querySelector('.featured-collection, .product-grid');
        if (productsSection) {
          productsSection.scrollIntoView({ behavior: 'smooth' });
        }
      };
    }

    // Show result step
    setTimeout(() => {
      resultStep.classList.add('active');
    }, 100);
  }

  /**
   * Copy discount code to clipboard
   */
  function copyDiscountCode() {
    const code = discountCodeEl.value;

    // Modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        showCopySuccess();
      }).catch(() => {
        fallbackCopy(code);
      });
    } else {
      fallbackCopy(code);
    }
  }

  /**
   * Fallback copy method
   */
  function fallbackCopy(text) {
    discountCodeEl.select();
    discountCodeEl.setSelectionRange(0, 99999); // For mobile

    try {
      document.execCommand('copy');
      showCopySuccess();
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }

  /**
   * Show copy success feedback
   */
  function showCopySuccess() {
    copyCodeBtn.classList.add('copied');
    const originalText = copyCodeBtn.querySelector('.copy-text').textContent;
    copyCodeBtn.querySelector('.copy-text').textContent = 'Copied!';

    setTimeout(() => {
      copyCodeBtn.classList.remove('copied');
      copyCodeBtn.querySelector('.copy-text').textContent = originalText;
    }, 2000);
  }

  /**
   * Handle shop now button
   */
  function handleShopNow() {
    // Default behavior is set in showResult
    // This is just a placeholder
  }

  /**
   * Check if user has already spun
   */
  function hasUserSpun() {
    return getCookie(COOKIE_NAME) === 'true';
  }

  /**
   * Set cookie that user has spun
   */
  function setUserSpun() {
    setCookie(COOKIE_NAME, 'true', cookieExpiryDays);
  }

  /**
   * Set a cookie
   */
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  /**
   * Get a cookie
   */
  function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }

    return null;
  }

  // Initialize on DOM ready with retry for trigger button
  function tryInit() {
    const triggerCheck = document.getElementById('spinWheelTriggerBtn');
    if (triggerCheck) {
      init();
    } else {
      // Retry after a short delay if trigger button not found yet
      setTimeout(tryInit, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // Re-initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#spinWheelPopup')) {
      setTimeout(init, 100);
    }
  });

})();
